import { i18n } from 'i18next';
import { deleteSociety } from 'modules/society/utils/deleteSociety';

const societyOptions = (i18n: i18n) => [
  {
    icon: 'ni-eye',
    text: i18n.t('SeePartners'),
    url: '/socios',
  },
  {
    icon: 'ni-edit',
    text: i18n.t('Edit'),
    url: '/perfil-sociedad/datos',
  },
  {
    icon: 'ni-trash',
    text: i18n.t('Delete'),
    action: deleteSociety,
  },
];
export default societyOptions;
